export const capitalizeString = (str) => {
  if (!str) return '';
  return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
};

// Format numbers with commas and 2 decimal places (e.g., 1,000.23)
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return '0.00';
  return Number(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

// Currency configuration with symbol and position
const CURRENCY_CONFIG = {
  'USD': { symbol: '$', position: 'before' },
  'EUR': { symbol: '€', position: 'after' },
  'GBP': { symbol: '£', position: 'before' },
  'PLN': { symbol: 'zł', position: 'after' },
  'DKK': { symbol: 'kr', position: 'after' },
  'CAD': { symbol: 'C$', position: 'before' },
  'AUD': { symbol: 'A$', position: 'before' },
  'CHF': { symbol: 'CHF', position: 'after' },
  'JPY': { symbol: '¥', position: 'before' },
  'SEK': { symbol: 'kr', position: 'after' },
  'NOK': { symbol: 'kr', position: 'after' }
};

// Get currency symbol
export const getCurrencySymbol = (currency) => {
  return CURRENCY_CONFIG[currency]?.symbol || currency;
};

// Format amount with currency symbol in correct position
export const formatAmountWithCurrency = (amount, currency) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    amount = 0;
  }
  
  const formattedAmount = formatCurrency(amount);
  
  // Handle null or undefined currency
  if (!currency) {
    return formattedAmount; // Just return the formatted amount without currency
  }
  
  const config = CURRENCY_CONFIG[currency];
  
  if (!config) {
    return `${currency} ${formattedAmount}`;
  }
  
  if (config.position === 'before') {
    return `${config.symbol}${formattedAmount}`;
  } else {
    return `${formattedAmount} ${config.symbol}`;
  }
};
